import { createStyles, Group } from '@mantine/core';
import { IconButton, Text } from '@repo/foundations';
import { buttonHoverTransition } from '@repo/theme/primitives';
import type { AiSettingStore } from '../store';

export interface AiSettingProps {
	store: AiSettingStore;
	onDelete: () => void;
	onClick: () => void;
}

const useStyles = createStyles((theme) => ({
	root: {
		width: '100%',
		padding: theme.spacing.md,
		'&:not(:hover) .right-component-hover': {
			opacity: 0,
		},
		'&:hover .right-component-hover': {
			opacity: 1,
			...buttonHoverTransition('opacity'),
		},
		'&:hover': {
			backgroundColor: theme.other.getColor('surface/secondary/default'),
		},
	},
	aiSettingContent: {
		gap: theme.spacing['3xs'],
		padding: 0,
	},
}));

export function AiSetting({ store, onDelete, onClick }: AiSettingProps) {
	const { classes } = useStyles();

	const descriptionBinding = store?.aiSettingAction.bind_description;
	const documentationBinding = store?.aiSettingAction.bind_definition;
	const ownersBinding = store?.aiSettingAction.bind_owners;
	const tagsBinding = store?.aiSettingAction.bind_tags;
	const piiBinding = store?.aiSettingAction.bind_pii;

	const bindings =
		[
			descriptionBinding ? 'Description' : null,
			documentationBinding ? 'Documentation' : null,
			ownersBinding ? 'Owners' : null,
			tagsBinding ? 'Tags' : null,
			piiBinding ? 'PII' : null,
		]
			.filter(Boolean)
			.join(', ') || 'no bindings';

	return (
		<Group
			position="apart"
			className={classes.root}
			onClick={onClick}
			style={{ cursor: 'pointer' }}
		>
			<Group className={classes.aiSettingContent}>
				<Group spacing="0">
					<Text size="sm" variant="tertiary" color="text/primary/default">
						{bindings}
					</Text>
				</Group>
			</Group>
			<Group spacing="3xs">
				<IconButton
					iconName="x"
					onClick={(event) => {
						event.stopPropagation();
						onDelete();
					}}
					variant="tertiary"
					tooltip={'Remove AI output'}
					className="right-component-hover"
					includeOffset
				/>
			</Group>
		</Group>
	);
}
